module.exports = __webpack_public_path__ + "static/media/rebate-color.370f3f9f.png";